import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-md border border-gray-200 p-4 mb-3" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "flex items-center justify-between mb-1" }
const _hoisted_4 = { class: "flex items-center gap-1.5" }
const _hoisted_5 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_6 = ["href", "title"]
const _hoisted_7 = { class: "text-xs text-gray-500 leading-relaxed" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 1,
  class: "p-3 bg-royal-blue-50/50 border border-royal-blue-100 rounded-md"
}
const _hoisted_11 = { class: "flex justify-between items-center mb-2" }
const _hoisted_12 = { class: "flex items-center gap-2" }
const _hoisted_13 = { class: "text-xs font-semibold text-royal-blue-900 animate-pulse" }
const _hoisted_14 = { class: "text-xs font-medium text-royal-blue-700" }
const _hoisted_15 = { class: "w-full bg-royal-blue-200 h-1.5 rounded-full overflow-hidden relative" }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = ["onClick", "title"]
const _hoisted_18 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center text-gray-400 text-[10px]"
}
const _hoisted_19 = { class: "absolute -bottom-1 -right-1 bg-white border border-gray-200 rounded-full w-5 h-5 flex items-center justify-center text-[9px] font-bold text-gray-700 z-10" }
const _hoisted_20 = { class: "flex items-center justify-between mt-4 pt-3 border-t border-gray-100" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = ["disabled", "title"]
const _hoisted_25 = {
  key: 3,
  class: "mb-1 p-4 bg-gray-50 border border-gray-200 rounded-md text-center"
}
const _hoisted_26 = { class: "text-sm font-semibold text-gray-900 mb-1" }
const _hoisted_27 = { class: "text-xs text-gray-500 mb-4" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 4,
  class: "mb-1 p-3 bg-red-50 border border-red-200 rounded-md text-xs text-red-700"
}
const _hoisted_30 = { class: "mb-2" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SparklesIcon = _resolveComponent("SparklesIcon")!
  const _component_QuestionMarkCircleIcon = _resolveComponent("QuestionMarkCircleIcon")!
  const _component_CroppedFaceImage = _resolveComponent("CroppedFaceImage")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_ArrowPathIcon = _resolveComponent("ArrowPathIcon")!
  const _component_DeleteFolderConfirmationModalComponent = _resolveComponent("DeleteFolderConfirmationModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('people_block.title')), 1),
            _createVNode(_component_SparklesIcon, {
              class: "w-4 h-4 text-royal-blue-600",
              title: _ctx.$t('people_block.ai_badge'),
              "aria-label": "AI"
            }, null, 8, ["title"]),
            _createElementVNode("a", {
              href: _ctx.helpUrl,
              target: "_blank",
              rel: "noopener noreferrer",
              class: "text-gray-400 hover:text-royal-blue-600 transition-colors",
              title: _ctx.$t('people_block.learn_more')
            }, [
              _createVNode(_component_QuestionMarkCircleIcon, { class: "w-4 h-4" })
            ], 8, _hoisted_6)
          ])
        ]),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('people_block.description')), 1)
      ]),
      (_ctx.viewState === 'initial')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmStart && _ctx.confirmStart(...args)), ["prevent"])),
              disabled: _ctx.loading,
              class: "w-full flex items-center justify-center gap-2 px-3 py-2 bg-white border border-royal-blue-200 hover:bg-royal-blue-50 hover:border-royal-blue-300 text-royal-blue-700 rounded-md text-sm font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
            }, [
              _cache[6] || (_cache[6] = _createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"w-4 h-4\"><path d=\"M3 7V5a2 2 0 0 1 2-2h2\"></path><path d=\"M17 3h2a2 2 0 0 1 2 2v2\"></path><path d=\"M21 17v2a2 2 0 0 1-2 2h-2\"></path><path d=\"M7 21H5a2 2 0 0 1-2-2v-2\"></path><path d=\"M8 14s1.5 2 4 2 4-2 4-2\"></path><path d=\"M9 9h.01\"></path><path d=\"M15 9h.01\"></path></svg>", 1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('people_block.find_faces')), 1)
            ], 8, _hoisted_9)
          ]))
        : _createCommentVNode("", true),
      (_ctx.viewState === 'scanning')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[7] || (_cache[7] = _createElementVNode("svg", {
                  class: "w-4 h-4 text-royal-blue-600 animate-spin",
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("circle", {
                    class: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "4"
                  }),
                  _createElementVNode("path", {
                    class: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  })
                ], -1)),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('people_block.analyzing')), 1)
              ]),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.job?.processed_photos || 0) + " / " + _toDisplayString(_ctx.job?.total_photos || 0), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", {
                class: "bg-royal-blue-600 h-full rounded-full transition-all duration-500",
                style: _normalizeStyle(`width: ${_ctx.progress}%`)
              }, null, 4)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.viewState === 'completed')
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", {
              class: "flex flex-wrap gap-2 gap-y-4 relative overflow-hidden transition-[max-height] duration-300 ease-in-out px-1 -mx-1 pt-1 pb-2",
              style: _normalizeStyle(_ctx.facesContainerStyle)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedPeople, (person) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: `person-face-${person.id}`,
                  onClick: _withModifiers(($event: any) => (_ctx.selectPerson(person)), ["prevent"]),
                  class: "relative group outline-none shrink-0 cursor-pointer transition-transform duration-200 hover:scale-110",
                  title: _ctx.$t('people_block.person')
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass([
                            'w-11 h-11 rounded-full overflow-hidden bg-gray-100 border-2 transition-all',
                            _ctx.isPersonSelected(person)
                                ? 'border-royal-blue-500 ring-2 ring-royal-blue-100 ring-offset-1'
                                : 'border-transparent group-hover:border-royal-blue-300'
                        ])
                  }, [
                    (person.cover_preview_url)
                      ? (_openBlock(), _createBlock(_component_CroppedFaceImage, {
                          key: 0,
                          src: person.cover_preview_url,
                          bbox: person.cover_bbox,
                          size: 44,
                          alt: _ctx.$t('people_block.person'),
                          class: "w-full h-full"
                        }, null, 8, ["src", "bbox", "alt"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.$t('people_block.no_cover')), 1))
                  ], 2),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(person.faces_count), 1)
                ], 8, _hoisted_17))
              }), 128))
            ], 4),
            _createElementVNode("div", _hoisted_20, [
              (_ctx.people.length > _ctx.initialVisibleCount)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleFaces && _ctx.toggleFaces(...args)), ["prevent"])),
                    class: "text-xs font-medium text-gray-500 hover:text-gray-900 transition-colors flex items-center gap-1 group cursor-pointer"
                  }, [
                    (!_ctx.expanded)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t('people_block.more_faces', { count: _ctx.people.length - _ctx.initialVisibleCount })), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t('people_block.collapse')), 1)),
                    _createVNode(_component_ChevronDownIcon, {
                      class: _normalizeClass(["w-3 h-3 transition-transform duration-300", {'rotate-180': _ctx.expanded}])
                    }, null, 8, ["class"])
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_23)),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmRerun && _ctx.confirmRerun(...args)), ["prevent"])),
                disabled: _ctx.loading,
                class: "text-xs font-medium text-gray-400 hover:text-royal-blue-600 transition-colors flex items-center gap-1 group disabled:opacity-50 cursor-pointer",
                title: _ctx.$t('people_block.rerun')
              }, [
                _createVNode(_component_ArrowPathIcon, { class: "w-3 h-3 group-hover:-rotate-180 transition-transform duration-500" }),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('people_block.rerun')), 1)
              ], 8, _hoisted_24)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.viewState === 'empty')
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"w-10 h-10 bg-white border border-gray-200 rounded-full flex items-center justify-center mx-auto mb-3\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"w-5 h-5 text-gray-400\"><path d=\"M13.5 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z\"></path><path d=\"M1 20a8 8 0 0 1 12.25-6.75\"></path><line x1=\"17\" x2=\"22\" y1=\"8\" y2=\"13\"></line><line x1=\"22\" x2=\"17\" y1=\"8\" y2=\"13\"></line></svg></div>", 1)),
            _createElementVNode("h3", _hoisted_26, _toDisplayString(_ctx.$t('people_block.no_faces_found')), 1),
            _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t('people_block.no_faces_hint')), 1),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmRerun && _ctx.confirmRerun(...args)), ["prevent"])),
              disabled: _ctx.loading,
              class: "text-xs font-medium text-royal-blue-600 hover:text-royal-blue-700 transition-colors flex items-center justify-center gap-1 mx-auto group disabled:opacity-50 cursor-pointer"
            }, [
              _createVNode(_component_ArrowPathIcon, { class: "w-3 h-3 group-hover:-rotate-180 transition-transform duration-500" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('people_block.try_again')), 1)
            ], 8, _hoisted_28)
          ]))
        : _createCommentVNode("", true),
      (_ctx.viewState === 'failed')
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("p", _hoisted_30, [
              _createTextVNode(_toDisplayString(_ctx.$t('people_block.failed')) + " ", 1),
              (_ctx.job?.error_message)
                ? (_openBlock(), _createElementBlock("span", _hoisted_31, "(" + _toDisplayString(_ctx.job.error_message) + ")", 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmRerun && _ctx.confirmRerun(...args)), ["prevent"])),
              disabled: _ctx.loading,
              class: "text-xs font-medium text-red-700 hover:text-red-800 transition-colors flex items-center gap-1 cursor-pointer"
            }, [
              _createVNode(_component_ArrowPathIcon, { class: "w-3 h-3" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('people_block.try_again')), 1)
            ], 8, _hoisted_32)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_DeleteFolderConfirmationModalComponent, {
      open: _ctx.pendingConfirm !== null,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.pendingConfirm = null)),
      onConfirmAction: _ctx.confirmModalAction,
      title: _ctx.pendingConfirm === 'rerun' ? _ctx.$t('people_block.confirm_rerun_title') : _ctx.$t('people_block.confirm_start_title'),
      message: _ctx.pendingConfirm === 'rerun' ? _ctx.$t('people_block.confirm_rerun') : _ctx.$t('people_block.confirm_start'),
      "button-text": _ctx.pendingConfirm === 'rerun' ? _ctx.$t('people_block.rerun') : _ctx.$t('people_block.find_faces'),
      variant: _ctx.pendingConfirm === 'rerun' ? 'danger' : 'info'
    }, null, 8, ["open", "onConfirmAction", "title", "message", "button-text", "variant"])
  ], 64))
}